import React from "react";
import { rp, num } from "../PlatformDashboard";
import { StatCard } from "../../../components/Drawer";

export function DokuSummary({ s }) {
  if (!s) return null;
  const st = s.by_status || {};
  const cards = [
    ["Pendapatan lunas", rp(s.paid_idr), `${num(s.paid_count)} invoice`, "doku-sum-paid-idr", true],
    ["Invoice lunas", num(s.paid_count), "status PAID", "doku-sum-paid-count"],
    ["Kredit terjual", num(s.paid_credits), "kredit masuk ke wallet", "doku-sum-credits"],
    ["Menunggu", num(st.PENDING?.count), rp(st.PENDING?.amount_idr), "doku-sum-pending"],
    ["Kedaluwarsa", num(st.EXPIRED?.count), `${num(st.FAILED?.count)} gagal · ${num(st.CREATE_FAILED?.count)} gagal dibuat`, "doku-sum-expired"],
    ["Konversi", `${Number(s.conversion_pct || 0).toLocaleString("id-ID", { maximumFractionDigits: 1 })}%`, "PAID ÷ semua invoice", "doku-sum-conversion"],
  ];
  return (
    <div className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-6" data-testid="doku-summary">
      {cards.map(([l, v, sub, id, accent]) => <StatCard key={id} label={l} value={v} sub={sub} testid={id} accent={accent} />)}
    </div>
  );
}
